export default {
  ENTER_ENTITY: 'map/ENTER_ENTITY',
  LEAVE_ENTITY: 'map/LEAVE_ENTITY',
  UNSET_HOVER_STATE: 'map/UNSET_HOVER_STATE',
  SET_BOUNDS: 'map/SET_BOUNDS',
  SET_ALL_FEATURE_BOUNDS: 'map/SET_ALL_FEATURE_BOUNDS',
  SET_CENTER: 'map/SET_CENTER',
  OPEN_MAP_PANEL: 'map/OPEN_MAP_PANEL',
  CLOSE_MAP_PANEL: 'map/CLOSE_MAP_PANEL',
  SET_VIEW_MODE: 'map/SET_VIEW_MODE',
};



// WEBPACK FOOTER //
// ./src/state/ducks/map/types.js